import { DrawAOIFeature } from "./types";

export const AOI_LAYER_ID = "aoi_layer";
export const AOI_FEATURE_KEY = "aoi_feature";
export const AOI_SOURCE_ID = "aoi_source";
export const EDIT_AOI_SOURCE_ID = "edit-aoi-vertices-source";

export const AOI_DRAWING_FEATURE_COLOR = "rgba(251, 191, 36, 0.2)";
export const AOI_DRAWING_FEATURE_STROKE_COLOR = "rgba(251, 191, 36, 0.5)";
export const AOI_DRAWING_FEATURE_STROKE_WIDTH = 2;

export const AOI_MODIFY_FEATURE_COLOR = "rgba(255, 255, 0, 0.2)";
export const AOI_MODIFY_FEATURE_STROKE_COLOR = "rgba(255, 255, 0, 0.5)";
export const AOI_MODIFY_FEATURE_STROKE_WIDTH = 2;

export const AOI_FEATURE_COLOR = "rgba(255, 0, 255, 0.7)";
export const AOI_FEATURE_STROKE_COLOR = "rgba(255, 0, 255, 1)";
export const AOI_FEATURE_STROKE_WIDTH = 2;

export const AOI_ACTIVE_FEATURE_COLOR = "rgba(255, 0, 0, 0.7)";
export const AOI_ACTIVE_FEATURE_STROKE_COLOR = "rgba(255, 0, 0, 1)";
export const AOI_ACTIVE_FEATURE_STROKE_WIDTH = 2;

// Only the active AOI is used to place an order, so every other one is drawn
// de-emphasised with a dashed outline. Units are line widths, so at
// AOI_..._STROKE_WIDTH 2 this renders 6px dashes / 4px gaps — deliberately
// finer than the [4, 3] the in-progress draw preview uses.
export const AOI_INACTIVE_LINE_DASH = [3, 2];

// An AOI outside the provider's accepted area. Red rather than a dimmed or
// dashed variant: this is not a de-emphasis, it is a shape that cannot be
// ordered, and it has to read that way at a glance.
export const AOI_INVALID_FEATURE_COLOR = "rgba(239, 68, 68, 0.75)";
export const AOI_INVALID_FEATURE_STROKE_COLOR = "rgba(248, 113, 113, 1)";

export const PREFIX_MAPLIBRE_LAYER = "layer-";
export const PREFIX_MAPLIBRE_SOURCE = "source-";
export const MAPLIBRE_BEFORE_ID = undefined;

export const buildDrawGeoJSON = (
      features: DrawAOIFeature[],
      activeFeatureId?: string | null,
      /** Ids whose area falls outside the provider's limits. */
      invalidFeatureIds?: Set<string>,
) =>
{
      return {
            type: "FeatureCollection",
            features: features
                  .filter(f => f.visible)
                  .map(f => ({
                        type: "Feature",
                        id: f.id,
                        properties: {
                              ...f.properties,
                              color: f.fill || f.properties?.color || AOI_FEATURE_COLOR, // FIX MÀU
                              // Drives the solid/dashed split between the AOI line layers.
                              // Written AFTER the spread so a stale properties.active from an
                              // earlier build cannot win.
                              active: f.id === activeFeatureId,
                              // Drives the red paint branch; left false rather than
                              // absent so the layer filters stay simple.
                              invalid: Boolean(invalidFeatureIds?.has(f.id)),
                        },
                        geometry: f.geometry
                  }))
      }
}
